// frontend/src/config.js
const API_BASE = process.env.REACT_APP_API || "http://localhost:8000";

export { API_BASE };